module.exports = __webpack_public_path__ + "img/resized-APP-0025-1.91e8e8f4.png";